import { render, staticRenderFns } from "./ReportsGenerator.vue?vue&type=template&id=70524288"
import script from "./ReportsGenerator.vue?vue&type=script&lang=js"
export * from "./ReportsGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports